module.exports = __webpack_public_path__ + "mosaic.png?7330765768dd342e1d1d0fef1d4eda06";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mosaic.png
// module id = 97
// module chunks = 0